export const MARGIN = { top: 20, right: 20, bottom: 20, left: 20 };

export const CHART_SIZE = { width: 320, height: 200 };
